export enum ContentTypes {
  JSON = 'application/json',
  FORM_URLENCODED = 'application/x-www-form-urlencoded'
}
